import { render, staticRenderFns } from "./OnlineClassRoomList.vue?vue&type=template&id=0f40feea&scoped=true"
import script from "./OnlineClassRoomList.vue?vue&type=script&lang=js"
export * from "./OnlineClassRoomList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f40feea",
  null
  
)

export default component.exports